export const CONSTANTS = {

};
export const NOTIFICATION_DURATION_IN_SEC = 3;